let default_width = window.innerWidth;//アクセスした時の横幅を取得 スクロールバーを含めた値
let resize_width = window.innerWidth;
const break_point = 767;
jQuery(function() {
  let default_height = jQuery(document).innerHeight();//アクセスした時の高さを取得

  if (default_width > break_point) {
    let headerHeight = jQuery(".l-header").height();
    jQuery(".c-title-page").css("padding-top",headerHeight);
  }
  /*------------------------*/
  //リンクの範囲を広くする
  /*------------------------*/
  jQuery(".widelink").on('click',function() {
    let url = jQuery(this).find("a").attr("href");
    if (jQuery(this).find("a").attr("target") == '_blank') {
      window.open(url, '_blank');
      return false;
    } else {
      window.location = url;
      return false;
    }
  });

  jQuery(".widelink--sp").on('click',function(){
    if (default_width <= break_point) {
      window.location=jQuery(this).find("a").attr("href");
      return false;
    }
  });

  //スムーススクロール（ページ内リンク）
  jQuery('a[href^="#"]').on("click", function () {
    const f = 600;
    e = jQuery(this).attr("href"),
    g = jQuery(e == "#" || e == "" ? "html" : e),
    h = jQuery(".l-header").height(),
    d = g.offset().top - h;
    jQuery("html, body").animate({
      scrollTop: d
    }, f, "swing");
    return false
  });
  jQuery('.js-scroll').on("click", function () {
    const f = 600;
    e = jQuery(this).attr("href"),
    g = jQuery(e == "#" || e == "" ? "html" : e),
    h = jQuery(".l-header").height(),
    d = g.offset().top - h;
    jQuery("html, body").animate({
      scrollTop: d
    }, f, "swing");
    return false
  });

  //tab
  jQuery('.js-tab-menu .js-tab-menu__item').on('click',function() {
    let i = jQuery(this).index();
    // クリック済みタブのデザインを設定したcssのクラスを一旦削除
    jQuery(this).siblings().removeClass('is-active');
    // クリックされたタブにクリック済みデザインを適用する
    jQuery(this).addClass('is-active');
    // コンテンツを一旦非表示にし、クリックされた順番のコンテンツのみを表示
    jQuery(this).parents(".js-tab-menu").next(".js-tab-target").children(".js-tab-target__item").hide().removeClass("is-show").eq(i).fadeIn(300).addClass("is-show");
  });

  //accordion
  jQuery('.js-accordion .js-accordion__item:nth-child(1)').addClass('open'); // 1番目にある.accordion-headerにクラスactiveを追加
  jQuery('.js-accordion .js-accordion__item:nth-child(1) .js-accordion__content').css('display', 'block'); // 2番目にある.accordion-contentにdisplay: block;を追加
  jQuery(".js-accordion__header").on('click',function() {
    jQuery(this).parents(".js-accordion__item").toggleClass("open");
    jQuery(this).next(".js-accordion__content").slideToggle();
  });

  //pulldown
  jQuery(".js-pulldown .js-pullDownList").on('click',function() {
    jQuery(this).toggleClass("is-show").find(".js-pullDownItem").not(":first").slideToggle();
  });

  //追従バナー
  const fixB = jQuery(".fixBnr");
  if (fixB.length) {
    jQuery(window).on('scroll',function () {
      let doch = jQuery(document).innerHeight(), //ページ全体の高さ
      winh = jQuery(window).innerHeight(), //ウィンドウの高さ
      bottom = doch - winh, //ページ全体の高さ - ウィンドウの高さ = ページの最下部位置
      footh = jQuery(".footer").innerHeight();
      if (jQuery(this).scrollTop() > 100 && jQuery(this).scrollTop() < bottom - footh) {
        fixB.addClass("show");
      } else {
        fixB.removeClass("show");
      }
    });
  }

  /*----------------------------------------------------*/
  /* [PC][SP]UseragentでJSを切り替え
  /*----------------------------------------------------*/
  let getDevice = (function() {
  let ua = navigator.userAgent;
    if (!(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
      /*-------------------------------------*/
      /* PCの時
      /*-------------------------------------*/
      jQuery(".widelink").hover(
        function(e) {
            jQuery(this).addClass("hover");
        },
        function(e) {
            jQuery(this).removeClass("hover");
        }
      );
    }
  })();

  /*------------------------*/
  //バーガーメニュー表示・非表示
  /*------------------------*/
  const burgerBtn = jQuery('.l-header__burger-button');
  let headerHeight = jQuery('.l-header').innerHeight();
  let headerInnerHeight = jQuery('.l-header').height();
  // スクロールがヘッダーの高さに達したらボタン表示
  jQuery(window).scroll(function () {
    if (!jQuery(".l-header__burger-button").hasClass("is-open")) {
      if (jQuery(this).scrollTop() > headerInnerHeight) {
        burgerBtn.addClass("is-fixedNav");
      } else if (jQuery(this).scrollTop() < headerInnerHeight) {
        if (burgerBtn.hasClass("is-fixedNav")) {
          burgerBtn.removeClass("is-fixedNav");
        }
      } else {
        if (burgerBtn.hasClass("is-fixedNav")) {
          burgerBtn.removeClass("is-fixedNav");
        }
      }
    }


    if (jQuery(this).scrollTop() > headerInnerHeight) {
      jQuery(".l-header").addClass("js-fixed-nav");
    } else if (jQuery(this).scrollTop() < headerInnerHeight) {
      if (jQuery(".l-header").hasClass("js-fixed-nav")) {
        jQuery(".l-header").removeClass("js-fixed-nav");
      }
    } else {
      if (jQuery(".l-header").hasClass("js-fixed-nav")) {
        jQuery(".l-header").removeClass("js-fixed-nav");
      }
    }
  });
  //バーガーボタンクリック
  burgerBtn.on('click',function() {
    default_width = window.innerWidth;//クリックされた時の数値をdefault_widthに設定
    burgerBtn.toggleClass("is-open");
    if (jQuery(".l-header__burgerNav").hasClass("show")) {
      jQuery(".l-header__burgerNav").removeClass("show").addClass("hide");
    } else if (jQuery(".l-header__burgerNav").hasClass("hide")) {
      jQuery(".l-header__burgerNav").removeClass("hide").addClass("show");
    } else {
      jQuery(".l-header__burgerNav").addClass("show");
    }
    if (jQuery(this).hasClass("is-open")) { //バーガーメニューが開かれた状態か
      jQuery(".l-header__cover").removeClass("hide").addClass("show");
    } else {
      jQuery(".l-header__cover").addClass("hide").removeClass("show");
    }
    // 現在のbodyタグのoverflowスタイルを確認
    if ($("html").css("overflow") === "hidden") {
      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      $("html").removeClass("noScroll");
    } else {
      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      $("html").addClass("noScroll");
    }
  });
  //カバーをクリック
  jQuery(".l-header__cover,.l-header__burgerNavList__item a").on('click',function() {
    jQuery(".l-header__cover").addClass("hide").removeClass("show");
    jQuery(".l-header__burgerNav").removeClass("show").addClass("hide");
    burgerBtn.removeClass("is-open");
  });
  //バーガー内トグルをクリック
  jQuery(".l-header__menu--trigger.js-toggle").children(".l-header__menu").show();
  jQuery(".l-header__menu--trigger").on('click',function() {
    if (default_width <= 768) {
      jQuery(this).children(".l-header__menu").slideToggle(300);
      jQuery(this).toggleClass("js-toggle");
    }
  });
  
  /*------------------------*/
  //リサイズ時の処理（リサイズした瞬間に走る）
  /*------------------------*/
  jQuery(window).on('resize',function() {
    if (default_width == window.innerWidth){//アクセスした時と、リサイズした時のウィンドウ幅が同じかどうかを判定
      return;//アクセスした時と、リサイズした時のウィンドウ幅が同じだった時に処理を抜ける
    } else {
      default_width = window.innerWidth;//リサイズ処理がされた場合、default_widthの数値を更新
      resize_width = window.innerWidth;//リサイズが完了したらウィンドウサイズの更新
      if (resize_width <= break_point) {
        /*------------------------*/
        //スマホ処理（リサイズ時）
        /*------------------------*/
        //バーガーメニューを開いたままリサイズされた時の処理
        jQuery(".l-header__nav").removeClass("is-show is-hide");
        burgerBtn.removeClass("is-open");
        jQuery(".l-header__cover").addClass("is-hide").removeClass("show");
        jQuery(".l-header__menu--trigger").removeClass("js-toggle");
        jQuery(".l-header__menu--trigger").children(".l-header__menu").hide();
      } else {
        /*------------------------*/
        //PC処理（リサイズ時）
        /*------------------------*/
        jQuery(".l-header__nav").removeClass("is-show is-hide");
        jQuery(".l-header__menu--trigger").removeClass("js-toggle");
        jQuery(".l-header__menu--trigger").children(".l-header__menu").show();
      }
    }
  });

  /*------------------------*/
  //リサイズ完了時点処理（完了するまで処理されない）
  /*------------------------*/
  let timer = false;
  jQuery(window).on('resize',function() {
    if (timer !== false) {
        clearTimeout(timer);
    }
    timer = setTimeout(function() {
      resize_width = window.innerWidth;//リサイズが完了したらウィンドウサイズの更新
      if (resize_width <= break_point) {
        /*------------------------*/
        //スマホ処理（リサイズ完了時）
        /*------------------------*/
        // jQueryheader.removeClass(scrollClass);
        jQuery(".c-title-page").css("padding-top", "inherit");
      } else {
        /*------------------------*/
        //PC処理（リサイズ完了時）
        /*------------------------*/
        let headerHeight = jQuery(".l-header").height();
        jQuery(".c-title-page").css("padding-top", headerHeight);
      }
      docH = jQuery(document).height(),
      winH = jQuery(window).height()
      footeH = jQuery('.footer').outerHeight(),
      topBtnPos = docH - winH - footeH;
    }, 200);
  });
});